import { useAppLogo } from "helpers/useAppSetting";
import { CHECK_DISPLAY_CLS } from "../pifStyles";
import { formatDate } from "helpers/utils";
import { Link } from "react-router-dom";
import React from 'react';
import PropTypes from 'prop-types';

const BDS3 = ({pif, area}) => {
  const logo = useAppLogo();
  const {project, building, adaptation} = pif;
  const bds3 = area?.bds3 || {};

  const projectUrl = `/crm/projects/${project?.id}`;

  return (
    <table className="tw-text-sm tw-mt-5">
      <tr>
        <td colSpan="2" className="tw-text-left tw-font-bold">
          Building Data Sheet 3
        </td>
        <td colSpan="6" className="tw-text-center">
          <div className="tw-text-2xl tw-font-bold tw-mb-2">PROJECT INFORMATION FORM</div>
        </td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          This building only: 3 of 3
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="2" className="tw-text-center">
          <img
            src={logo}
            alt="Logo Pebsteel"
            width="160"
            height="60"
            className="tw-object-contain tw-rounded-sm"
            style={{maxWidth: '100%'}}
          />
        </td>
        <td className="tw-font-bold">Quote No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{project?.q_number}</Link>
        </td>
        <td className="tw-font-bold">Rev No:</td>
        <td className="tw-text-primary-600">{adaptation.rev}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <div className="tw-flex tw-justify-around">
            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_order_entry"
                checked={!!(adaptation?.type === "change_order")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Order Entry</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_quotation"
                checked={!!(adaptation?.type === "revision")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Quotation</span>
            </label>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-font-bold">P/Job No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{building?.j_number}</Link>
        </td>
        <td className="tw-font-bold">CO#:</td>
        <td className="tw-text-primary-600">{adaptation.co}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <div className="tw-flex tw-justify-around">
            <div>
              Bldg No: <span className="tw-text-primary-600">{building?.name}</span>
            </div>
            <div>
              Area No: <span className="tw-text-primary-600">{area?.id}</span>
            </div>
          </div>
          <h6 className="tw-text-center tw-my-2">This area only : Page 3 of 3</h6>
        </td>
      </tr>
      <tr>
        <td colSpan="10">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-5 tw-font-semibold">1. Please design the most economical purlin, girt spacing.</div>
            <div className="tw-col-span-7">
              <span className="tw-text-primary-600">{bds3.purlin_girt_spacing}</span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="10">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-5 tw-font-semibold">2. Deflection criterion:</div>
            <div className="tw-col-span-7">
              <div className="tw-flex tw-justify-around">
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.follow_building_code)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Follow building code</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.follow_peb_standard)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Follow peb standard</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.follow_requested_of_client)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Follow requested of client</span>
                </label>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-5 tw-mx-3">Requested of Client:</div>
            <div className="tw-col-span-7">
              <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: bds3.follow_requested_of_client_specify }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="10">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-3">
            <div className="tw-col-span-4 tw-font-semibold">3. Environment conditions:</div>
            <div className="tw-col-span-8">
              <div className="tw-flex tw-justify-around">
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.fertilizer)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Fertilizer</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.chemical_substance)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Chemical substance</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.animal_feed)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Animal feed</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.animal_shed)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Animal shed</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.from_the_sea_100m)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>From the sea 100m</span>
                </label>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="10">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-3">
            <div className="tw-col-span-5 tw-font-semibold">4. How many cranes can operate at the same time in the same bay?</div>
            <div className="tw-col-span-7">
              <div className="tw-flex tw-justify-around">
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.crane_operate_2)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>2</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.crane_operate_3)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>3</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.crane_operate_4)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>4</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.crane_operate_not_apply)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Not Apply</span>
                </label>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="10">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-3">
            <div className="tw-col-span-5 tw-font-semibold">5. Is Internal X-Bracing allowed?</div>
            <div className="tw-col-span-7">
              <div className="tw-flex tw-justify-around">
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.internal_xbracing_yes)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Yes</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.internal_xbracing_no)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>No</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds3.internal_xbracing_not_apply)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Not Apply</span>
                </label>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="10">
          <div className="tw-flex tw-gap-2 tw-mb-3">
            <div className="tw-flex-1">
              <div className="tw-font-semibold">6. The Top Coat Paint shall be Flat or Matte Finish ( Very low on Reflectivity)</div>
              <div className="tw-mt-3">
                <span dangerouslySetInnerHTML={{ __html: bds3.top_coat_paint }}></span>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  )
};

BDS3.propTypes = {
  pif: PropTypes.object.isRequired,
  area: PropTypes.array.isRequired
}

export default BDS3;
